import { SendgridEnv } from '@west-australian-newspapers/email-queue-message-types'
import { Theme, themedValue } from '../__styling'
import { NewsletterSubscriptionOptionsItem } from './components/NewsletterSubscriptionOptions/NewsletterSubscriptionOptions'

export function getNewsletterSubscriptionOptions(
    theme: Theme,
    environment: SendgridEnv,
): NewsletterSubscriptionOptionsItem[] {
    if (environment === 'development') {
        return [
            {
                id: 'wan_digitaldev-dev-unsubscribe-group',
                name: 'Digital Dev | Suppression Group',
                description: 'A test description for styling',
            },
        ]
    }

    return themedValue<
        NewsletterSubscriptionOptionsItem[],
        NewsletterSubscriptionOptionsItem[],
        NewsletterSubscriptionOptionsItem[]
    >(theme, {
        thewest: [
            {
                id: 'wan_newsletter-west-news',
                name: 'The West | News Headlines',
                description: 'Daily news headlines from our newsroom',
            },
            {
                id: 'wan_newsletter-west-breaking-news',
                name: 'The West | Breaking News',
                description:
                    'Breaking news headlines as they happen from The West Australian',
            },
            {
                id: 'wan_newsletter-west-sport',
                name: 'The West | Sport News',
                description: 'The latest in Sport from The West Australian',
            },
            {
                id: 'wan_newsletter-west-business',
                name: 'The West | Business News',
                description: 'The latest in Business from The West Australian',
            },
            {
                id: 'wan_newsletter-west-bulls-n-bears',
                name: `Bulls N' Bears | Public Companies`,
                description: `The latest in public companies from Bulls N' Bears.`,
            },
            {
                id: 'wan_newsletter-west-tomorrows-front-page',
                name: `The West | Tomorrow's Front Page`,
            },
            {
                id: 'wan_travelclub-enews',
                name: `West Travel Club E-News`,
            },
        ],
        perthnow: [
            {
                id: 'wan_newsletter-perthnow-am-briefing',
                name: 'PerthNow | News Briefing',
                description: 'Daily news headlines from our newsroom',
            },
            {
                id: 'wan_newsletter-perthnow-breaking',
                name: 'PerthNow | Breaking News',
                description:
                    'Breaking news headlines as they happen from PerthNow',
            },
            {
                id: 'wan_newsletter-perthnow-celebrity',
                name: 'PerthNow | Celebrity News',
                description: 'The latest in Celebrity News from PerthNow',
            },
            {
                id: 'wan_newsletter-perthnow-weird',
                name: 'PerthNow | Weird News',
                description: 'The latest in Weird News from PerthNow',
            },
        ],
        fallback: [],
    })
}
